<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Border Lord</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="reviewPage" id="rev"><h2 class="reviewPageHead"><span class="bold"><span>Praise for Sophia James</span></span></h2><p class="reviewPageSubhead"><span><span class="bold"><span>High Seas to High Society</span></span></span></p><p class="reviewPageText"><span>“James weaves her spell, captivating readers with wit and wisdom, and cleverly combining humor and poignancy with a master’s touch in this feel-good love story.”</span></p><p class="reviewPageSource"><span>—<em class="italic"><span>Romantic Times BOOKreviews</span></em></span></p><p class="reviewPageSubhead"><span><span class="bold"><span>Masquerading Mistress</span></span></span></p><p class="reviewPageText"><span>“Bold and tantalizing, plotted like a mystery and slowly exposing each layer of the multidimensional plot and every character’s motivations, James’ novel is a page-turner.”</span></p><p class="reviewPageSource"><span>—<em class="italic"><span>Romantic Times BOOKreviews</span></em></span></p><p class="reviewPageSubhead"><span><span class="bold"><span>Ashblane’s Lady</span></span></span></p><p class="reviewPageText"><span>“An excellent tale of love, this book is more than a romance; it pulls at the heartstrings and makes you wish the story wouldn’t end.”</span></p><p class="reviewPageSource"><span>—<em class="italic"><span>Romantic Times BOOKreviews</span></em></span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// borderlordthe_rev.vue?22a43bcf